import { render, staticRenderFns } from "./NpcBehaviorSelector.vue?vue&type=template&id=6a2d03ba&scoped=true&"
import script from "./NpcBehaviorSelector.vue?vue&type=script&lang=js&"
export * from "./NpcBehaviorSelector.vue?vue&type=script&lang=js&"
import style0 from "./NpcBehaviorSelector.vue?vue&type=style&index=0&id=6a2d03ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2d03ba",
  null
  
)

export default component.exports